import Header from '../components/Header'
import HeroBanner from '../components/GetStarted/HeroBanner'
import DividerShape from '../components/SwitchToUs/DividerShape'
import WhyDirectMail from '../components/GetStarted/WhyDirectMail'
import Roadmap from '../components/GetStarted/Roadmap'
import NeedHelp from '../components/GetStarted/NeedHelp'
import FreeResources from '../components/GetStarted/FreeResources'
import JustinStory from '../components/GetStarted/JustinStory'
import Footer from '../components/Footer'
import { GeneralAPI } from '../apis/GeneralAPI'

export default function GetStarted({ data }) {
    return (
        <div>
            <Header metaTitle="Get Started" meta={data?.yoast_head} />
            <HeroBanner />
            <WhyDirectMail />
            <Roadmap />
            <NeedHelp />
            <FreeResources />
            <div className="rotate-180">
                <DividerShape />
            </div>
            <JustinStory />
            <Footer />
        </div>
    )
}

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/get-started')
    const data = page ? page[0] : {}
    return {
        props: { data },
        revalidate: 10, // In seconds
    }
}
